import { queryOptions } from '@tanstack/react-query'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import {
  CoutryList,
  GetCountryList,
  GetStateByContryId,
  GetTimeZoneList,
  StateList,
  TimeZoneList,
} from './requests.ts'

const ContryListKeys = {
  details: () => ['country_list'],
} as const
const StateQueryKeys = {
  details: (countryId: number) => ['state_list', countryId],
} as const
const TimeZonesKeys = {
  details: () => ['timezone_list'],
} as const
export class CommonQueries {
  public static FetchCommonCountries(
    options: CustomQueryOptions<CoutryList> = {}
  ) {
    return queryOptions({
      queryKey: ContryListKeys.details(),
      queryFn: () => GetCountryList(),
      ...options,
    })
  }
  public static FetchStateByContry(
    countryId?: number,
    options: CustomQueryOptions<StateList> = {}
  ) {
    return queryOptions({
      queryKey: StateQueryKeys.details(countryId!),
      queryFn: () => GetStateByContryId(countryId),
      ...options,
    })
  }
  public static FetchTimeZones(options: CustomQueryOptions<TimeZoneList> = {}) {
    return queryOptions({
      queryKey: TimeZonesKeys.details(),
      queryFn: () => GetTimeZoneList(),
      ...options,
    })
  }
}
